import { Outlet } from "react-router";
import Header from "../../../component/layout/header";
import useNav from "../../../script/tabingNavArray";

const ProjectDetailLayout = () => {
  const navList = useNav();
  let { ProjectDetailBottomHeader, topProjectNav } = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={ProjectDetailBottomHeader} topTabs={topProjectNav} />
      <Outlet />
    </div>
  );
};

export default ProjectDetailLayout;
